<div class="space-y-6 text-text-primary">

    <!-- Header -->
    <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
            <h2 class="text-xl font-bold tracking-tight mb-1">{{ 'brokerDashboard.offers.title' | translate }}</h2>
            <p class="text-text-muted text-sm">{{ totalItems }} {{ totalItems !== 1 ? ('brokerDashboard.offers.offers' | translate) : ('brokerDashboard.offers.offer' | translate) }}</p>
        </div>
         <!-- <div class="flex gap-1 bg-surface-input p-1 rounded-xl border border-border">
            <button (click)="switchType('unit')"
                [ngClass]="targetType === 'unit' ? 'bg-primary text-white shadow-primary-glow font-bold' : 'text-text-secondary hover:text-text-primary'"
                class="px-5 py-2 rounded-lg text-sm transition-all flex items-center">
                <i class="fas fa-home mr-2 text-xs"></i>{{ 'brokerDashboard.offers.unitsTab' | translate }}
            </button>
            <button (click)="switchType('property')"
                [ngClass]="targetType === 'property' ? 'bg-primary text-white shadow-primary-glow font-bold' : 'text-text-secondary hover:text-text-primary'"
                class="px-5 py-2 rounded-lg text-sm transition-all flex items-center">
                <i class="fas fa-building mr-2 text-xs"></i>{{ 'brokerDashboard.offers.propertiesTab' | translate }}
            </button>
        </div> -->
    </div>

    <!-- Status filter tabs -->
    <div class="flex gap-2 flex-wrap">
        @for (f of [
        {id:'all', label:'brokerDashboard.offers.all'},
        {id:'pending', label:'brokerDashboard.offers.pending'},
        {id:'reviewing', label:'brokerDashboard.offers.reviewing'},
        {id:'negotiating', label:'brokerDashboard.offers.negotiating'},
        {id:'accepted', label:'brokerDashboard.offers.accepted'},
        {id:'rejected', label:'brokerDashboard.offers.rejected'}
        ]; track f.id) {
        <button (click)="setFilter($any(f.id))" [ngClass]="activeFilter === f.id
          ? 'bg-primary text-white shadow-primary-glow border border-primary font-bold'
          : 'bg-surface text-text-secondary border border-border hover:border-primary hover:text-text-primary font-medium'"
            class="px-5 py-2 rounded-xl text-sm transition-all">
            {{ f.label | translate }}
        </button>
        }
    </div>

    <!-- Loading -->
    @if (isLoading) {
    <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle overflow-hidden">
        <div class="overflow-x-auto">
              <table class="w-full text-left border-collapse">
                    <thead>
                          <tr class="border-b border-border bg-surface text-xs uppercase font-bold text-text-muted tracking-wider">
                                <th class="px-6 py-4">Buyer & Date</th>
                                <th class="px-6 py-4">Type & Status</th>
                                <th class="px-6 py-4">Financials</th>
                                <th class="px-6 py-4">Contact</th>
                                <th class="px-6 py-4 text-right">Actions</th>
                          </tr>
                    </thead>
                    <tbody class="divide-y divide-border-subtle">
                          @for (item of [1,2,3,4]; track item) {
                          <tr class="animate-pulse">
                                <td class="px-6 py-4">
                                      <div class="flex items-center gap-3">
                                            <div class="w-10 h-10 bg-surface-hover rounded-full"></div>
                                            <div class="space-y-2">
                                                  <div class="h-4 bg-surface-hover rounded w-24"></div>
                                                  <div class="h-3 bg-surface-hover rounded w-16"></div>
                                            </div>
                                      </div>
                                </td>
                                <td class="px-6 py-4 space-y-2">
                                      <div class="h-5 bg-surface-hover rounded-full w-20"></div>
                                      <div class="h-5 bg-surface-hover rounded-full w-24"></div>
                                </td>
                                <td class="px-6 py-4 space-y-2">
                                      <div class="h-4 bg-surface-hover rounded w-28"></div>
                                      <div class="h-4 bg-surface-hover rounded w-32"></div>
                                </td>
                                <td class="px-6 py-4 space-y-2">
                                      <div class="h-3 bg-surface-hover rounded w-24"></div>
                                      <div class="h-3 bg-surface-hover rounded w-28"></div>
                                </td>
                                <td class="px-6 py-4 text-right">
                                      <div class="h-8 bg-surface-hover rounded w-24 ml-auto"></div>
                                </td>
                          </tr>
                          }
                    </tbody>
              </table>
        </div>
    </div>
    }

    <!-- Error -->
    @if (error && !isLoading) {
    <div class="flex items-center gap-3 px-6 py-4 bg-danger-soft border border-danger-border rounded-2xl text-danger text-sm font-medium">
        <i class="fas fa-exclamation-circle text-lg"></i><span>{{ error }}</span>
        <button (click)="load()" class="ml-auto underline hover:no-underline font-bold">{{ 'brokerDashboard.common.retry' | translate }}</button>
    </div>
    }

    <!-- Empty -->
    @if (!isLoading && !error && filtered.length === 0) {
    <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-16 text-center">
        <div class="w-20 h-20 bg-surface border border-border-strong rounded-full flex items-center justify-center mx-auto mb-4 hover:bg-surface-hover transition-colors">
            <i class="fas fa-file-invoice-dollar text-text-muted text-3xl"></i>
        </div>
        <h3 class="text-xl font-bold text-text-primary mb-2">No Offers Found</h3>
        <p class="text-text-secondary text-sm max-w-sm mx-auto">{{ 'brokerDashboard.offers.noOffers' | translate }}</p>
    </div>
    }

    <!-- Data Table -->
    @if (!isLoading && !error && filtered.length > 0) {
    <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle overflow-hidden">
        <div class="overflow-x-auto">
              <table class="w-full text-left border-collapse whitespace-nowrap">
                    <thead>
                          <tr class="border-b border-border bg-surface text-xs uppercase font-bold text-text-muted tracking-wider">
                                <th class="px-6 py-4">Buyer & Date</th>
                                <th class="px-6 py-4">Type & Status</th>
                                <th class="px-6 py-4">Financials</th>
                                <th class="px-6 py-4">Contact</th>
                                <th class="px-6 py-4 text-right">Actions</th>
                          </tr>
                    </thead>
                    <tbody class="divide-y divide-border-subtle">
                          @for (offer of filtered; track offer._id) {
                          <tr class="hover:bg-surface-hover transition-colors group">
                                
                                <!-- Buyer & Date -->
                                <td class="px-6 py-4">
                                      <div class="flex items-center gap-3">
                                            <div class="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white font-bold text-sm flex-shrink-0 shadow-sm border border-primary-border">
                                                  {{ offer.buyerSnapshot.name.charAt(0).toUpperCase() }}
                                            </div>
                                            <div>
                                                  <div class="text-sm font-bold text-text-primary mb-0.5">{{ offer.buyerSnapshot.name }}</div>
                                                  <div class="text-xs font-medium text-text-secondary flex items-center gap-1.5">
                                                        <i class="fas fa-clock text-text-disabled"></i>
                                                        {{ timeAgo(offer.createdAt) }}
                                                  </div>
                                            </div>
                                      </div>
                                </td>

                                <!-- Type & Status -->
                                <td class="px-6 py-4">
                                      <div class="flex flex-col gap-2 items-start">
                                            <span class="px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border"
                                                  [ngClass]="offer.status === 'accepted' ? 'bg-success-soft text-success border-success-border' : (offer.status === 'rejected' ? 'bg-danger-soft text-danger border-danger-border' : (offer.status === 'negotiating' ? 'bg-warning-soft text-warning border-warning-border' : 'bg-primary-soft text-primary border-primary-border'))">
                                                  {{ offer.status }}
                                            </span>
                                            <span class="px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border bg-surface text-text-secondary border-border">
                                                  {{ offer.offerType }}
                                            </span>
                                      </div>
                                </td>

                                <!-- Financials -->
                                <td class="px-6 py-4">
                                      <div class="flex flex-col gap-1.5">
                                            <div class="flex items-center gap-2">
                                                  <span class="text-[10px] font-medium text-text-muted uppercase tracking-wider w-16">Offered</span>
                                                  <span class="text-sm font-bold text-primary">{{ fmt(offer.offeredPrice) }} EGP</span>
                                            </div>
                                            @if (offer.paymentPlanProposal) {
                                            <div class="flex items-center gap-2">
                                                  <span class="text-[10px] font-medium text-text-muted uppercase tracking-wider w-16">Down</span>
                                                  <span class="text-sm font-bold text-text-primary">{{ fmt(offer.paymentPlanProposal.downPaymentAmount) }} EGP</span>
                                            </div>
                                            <div class="text-[10px] font-medium text-text-secondary mt-1 flex items-center gap-2">
                                                  <span class="bg-surface px-2 py-0.5 rounded border border-border">{{ offer.paymentPlanProposal.years }} Years</span>
                                                  <span class="bg-surface px-2 py-0.5 rounded border border-border">{{ offer.paymentPlanProposal.interestRate }}% Interest</span>
                                            </div>
                                            }
                                      </div>
                                </td>

                                <!-- Contact -->
                                <td class="px-6 py-4">
                                      <div class="space-y-1.5 text-xs font-medium text-text-secondary">
                                            <div class="flex items-center gap-2">
                                                  <i class="fas fa-phone text-text-muted w-3 text-center"></i>
                                                  <a [href]="'tel:' + offer.buyerSnapshot.phone" class="hover:text-primary transition-colors">{{ offer.buyerSnapshot.phone }}</a>
                                            </div>
                                            <div class="flex items-center gap-2">
                                                  <i class="fas fa-envelope text-text-muted w-3 text-center"></i>
                                                  <a [href]="'mailto:' + offer.buyerSnapshot.email" class="hover:text-primary transition-colors truncate max-w-[150px]">{{ offer.buyerSnapshot.email }}</a>
                                            </div>
                                      </div>
                                </td>

                                <!-- Actions -->
                                <td class="px-6 py-4 text-right">
                                      <div class="flex items-center justify-end gap-2 opacity-60 group-hover:opacity-100 transition-opacity">
                                            @if (offer.status !== 'accepted' && offer.status !== 'rejected') {
                                            <button (click)="acceptOffer(offer._id)"
                                                  class="h-8 px-3 rounded-lg flex items-center justify-center text-xs font-semibold text-success hover:text-white hover:bg-success border border-transparent hover:border-success-border transition-colors"
                                                  title="{{ 'brokerDashboard.offers.accept' | translate }}">
                                                  <i class="fas fa-check"></i>
                                            </button>
                                            }
                                            <button (click)="openStatusModal(offer)"
                                                  class="h-8 px-3 rounded-lg flex items-center justify-center text-xs font-semibold text-text-secondary hover:text-primary hover:bg-primary-soft border border-transparent hover:border-primary-border transition-colors"
                                                  title="{{ 'brokerDashboard.offers.changeStatus' | translate }}">
                                                  <i class="fas fa-sliders-h mr-1.5"></i> {{ 'brokerDashboard.offers.status' | translate }}
                                            </button>
                                      </div>
                                </td>
                          </tr>
                          <!-- Expandable Notes Row -->
                          @if (offer.notes) {
                          <tr class="bg-surface-hover border-b border-border-subtle group-hover:bg-surface-hover/80 transition-colors">
                                <td colspan="5" class="px-6 py-3">
                                      <div class="flex items-start gap-2 text-xs text-text-secondary">
                                            <i class="fas fa-sticky-note text-text-muted mt-0.5"></i>
                                            <span class="whitespace-normal">{{ offer.notes }}</span>
                                      </div>
                                </td>
                          </tr>
                          }
                          }
                    </tbody>
              </table>
        </div>
    </div>
    }

</div>

<!-- ── Status Modal ─────────────────────────────────────────────────────────── -->
@if (showStatusModal && statusTarget) {
<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" (click)="closeStatusModal()">
    <div class="bg-surface-elevated border border-border rounded-2xl shadow-elevated w-full max-w-sm p-6 space-y-6" (click)="$event.stopPropagation()">

        <div class="flex items-center justify-between border-b border-border-subtle pb-4">
            <div>
                <h3 class="text-lg font-bold text-text-primary">{{ 'brokerDashboard.offers.changeStatusTitle' | translate }}</h3>
                <p class="text-xs font-medium text-text-muted mt-1">{{ statusTarget.buyerSnapshot.name }}</p>
            </div>
            <button (click)="closeStatusModal()" class="w-8 h-8 flex items-center justify-center hover:bg-surface-hover rounded-full transition-colors text-text-secondary hover:text-danger">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="space-y-3">
            @for (s of [
            {value:'pending', label:'brokerDashboard.offers.pending', cls:'bg-warning-soft text-warning border-warning-border'},
            {value:'reviewing', label:'brokerDashboard.offers.reviewing', cls:'bg-info-soft text-info border-info-border'},
            {value:'negotiating', label:'brokerDashboard.offers.negotiating', cls:'bg-primary-soft text-primary border-primary-border'},
            {value:'accepted', label:'brokerDashboard.offers.accepted', cls:'bg-success-soft text-success border-success-border'},
            {value:'rejected', label:'brokerDashboard.offers.rejected', cls:'bg-danger-soft text-danger border-danger-border'}
            ]; track s.value) {
            <label class="flex items-center gap-3 p-4 rounded-xl border cursor-pointer transition-all"
                [class.border-primary]="newStatus === s.value"
                [class.bg-surface-hover]="newStatus === s.value"
                [class.border-border]="newStatus !== s.value">
                <input type="radio" name="offerStatus" [value]="s.value" [(ngModel)]="newStatus" class="accent-primary w-4 h-4" />
                <span class="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider border" [ngClass]="s.cls">{{ s.label | translate }}</span>
            </label>
            }
        </div>

        <!-- Rejection reason -->
        @if (newStatus === 'rejected') {
        <div>
            <label class="block text-sm font-bold text-text-primary mb-2">{{ 'brokerDashboard.offers.rejectionReason' | translate }}</label>
            <textarea [(ngModel)]="rejectionReason" rows="3"
                [placeholder]="'brokerDashboard.offers.rejectionPlaceholder' | translate"
                class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition resize-none placeholder-text-muted"></textarea>
        </div>
        }

        <div class="flex gap-3 pt-2">
            <button (click)="closeStatusModal()"
                class="flex-1 py-3 border border-border text-text-primary font-bold rounded-xl text-sm hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.offers.cancel' | translate }}
            </button>
            <button (click)="saveStatus()" [disabled]="statusLoading"
                class="flex-1 py-3 bg-primary text-white rounded-xl text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-60 hover:bg-primary-hover shadow-primary-glow transition-all">
                @if (statusLoading) { 
                    <i class="fas fa-spinner fa-spin"></i> {{ 'brokerDashboard.offers.saving' | translate }} 
                } @else { 
                    {{ 'brokerDashboard.offers.saveChanges' | translate }} 
                }
            </button>
        </div>
    </div>
</div>
}